<template>    
    <ContentOrLoading>
        <b-container v-if="!loading">
            <b-row>         
                <b-col md="8" sm="12" id="svg">
                    <h3 class="subtitle h4 light mb-3 mb-lg-4">A) {{ $t('nuevo_abono.pinchando_mapa') }}:</h3>
                    <RenderSvgComponent
                        :svg="svg"
                        :zonas="zonas"
                        @clickZona="seleccionarZona"
                    />                            
                </b-col>
                <b-col md="4" sm="12">
                    <h3 class="subtitle h4 light mb-3 mb-lg-4 ">B) {{ $t('nuevo_abono.tabla') }}:</h3>
                    <TablaSectoresComponent 
                        :zonas="zonas" 
                        @clickZona="seleccionarZona"
                    />
                </b-col>               
            </b-row>
        </b-container>          
    </ContentOrLoading>
</template>

<script>
    import RenderSvgComponent from '@/components/common/svg/normal/RenderSvgComponent';
    import TablaSectoresComponent from '@/components/frontend/abonos/nuevo/TablaSectoresComponent';

    export default {
        props: {
            sga_event_id: {
                type: String,
                required: true
            },
            isPrivate: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                svg: null,
                zonas: [],
                loading: true,
                event_id: ''
            }
        },
        computed: {
            lista_abonados() {
                return this.$store.getters.getListaAbonados;
            },
            teatro(){
                return this.$store.getters.getTeatro
            }
        },
        created() {
            this.getZonas();
        },
        methods: {
            getZonas() {
                this.$store.dispatch(this.config.getVuexAlias('sga.get.zonas'), { 
                    event_id: this.sga_event_id,
                    filters: {
                        ...(this.isPrivate && { isPrivate: true })
                    }
                }).then(res => {
                    this.zonas = res.data.zonas;
                    this.svg = res.data.svg;
                    this.loading = false;
                    setTimeout(() => {
                        this.$scrollTo('#svg', 500);
                    }, 200);
                }).catch(e => {
                    console.error(e)
                });
            },
            seleccionarZona(zona) {
                this.$emit('zonaSeleccionada', zona);
            },
            volver() {
                alert('Volver');
            },
        },
        components: {
            RenderSvgComponent, TablaSectoresComponent
        }
    }
</script>